/** Chaves de cache do TanStack Query. Mudou o filtro, muda a chave, busca de novo. */
import type { PeriodQuery, PlacementQuery, Platform, ReportQuery } from '@/types/api';
export const qk = {
  me: ['me'] as const,
  prefs: ['prefs'] as const,
  myDomains: (company?: string) => ['myDomains', company ?? ''] as const,
  myDomainsAll: ['myDomains'] as const,
  myCompanies: ['myCompanies'] as const,
  companyOverview: (id: string, q: PeriodQuery) => ['companyOverview', id, q] as const,
  adminCompanies: ['adminCompanies'] as const,
  fxDiscount: ['fxDiscount'] as const,
  search: (q: string) => ['search', q] as const,
  dashboard: (q: PeriodQuery) => ['dashboard', q] as const,
  domains: (q: PeriodQuery) => ['domains', q] as const,
  domain: (d: string, q: PeriodQuery) => ['domain', d, q] as const,
  campaigns: (p: Platform, q: PeriodQuery, extra: object) => ['campaigns', p, q, extra] as const,
  children: (p: Platform, id: string, q: PeriodQuery) => ['children', p, id, q] as const,
  countries: (p: Platform, id: string, q: PeriodQuery) => ['countries', p, id, q] as const,
  urls: (q: PeriodQuery & { origin?: string }) => ['urls', q] as const,
  placementFilters: (d: string) => ['placementFilters', d] as const,
  placements: (q: PlacementQuery) => ['placements', q] as const,
  placementCampaigns: (q: PlacementQuery, p: string, level: string) => ['placementCampaigns', q, p, level] as const,
  gam: (q: PeriodQuery) => ['gam', q] as const,
  reportDaily: (month: string, q: ReportQuery) => ['reportDaily', month, q] as const,
  reportMonthly: (months: number, q: ReportQuery) => ['reportMonthly', months, q] as const,
  health: (q: PeriodQuery) => ['health', q] as const,
  fx: ['fx'] as const,
  fxHistory: ['fxHistory'] as const,
  utmTemplates: ['utmTemplates'] as const,
  integrations: ['integrations'] as const,
  adminDomains: ['adminDomains'] as const,
  unmapped: (p: string) => ['unmapped', p] as const,
  squads: ['squads'] as const,
  users: ['users'] as const,
  permissions: ['permissions'] as const,
  accounts: (p: string) => ['accounts', p] as const,
  syncSettings: ['syncSettings'] as const,
  finance: (q: object) => ['finance', q] as const,
  financeCosts: (q: object) => ['financeCosts', q] as const,
};
